import ManageDesks from './ManageDesks';
import Route from './route';

export default {
  RenderProp: ManageDesks,
  mainRoute: Route,
};
